export const PROVIDERS = ['by_user', 'cabinet_expert_comptable', 'other'] as const;

export type ProviderSource = (typeof PROVIDERS)[number];
